import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7601bcdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-popup-inner" }
const _hoisted_2 = { class: "frisbuy-popup-mobile-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Все фото покупателей", -1))
const _hoisted_4 = { class: "frisbuy-popup-content__media-column" }
const _hoisted_5 = { class: "frisbuy-popup-content__image" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src", "controls"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.8991 5.89646C14.2896 5.50599 14.9228 5.50607 15.3133 5.89646C15.7038 6.28699 15.7038 6.92016 15.3133 7.31068L10.6239 12.0001L15.3133 16.6895L15.3823 16.7655C15.7025 17.1582 15.6793 17.7377 15.3133 18.1037C14.9472 18.4696 14.3677 18.4929 13.975 18.1728L13.8991 18.1037L8.71454 12.9192C8.20709 12.4116 8.20718 11.5886 8.71454 11.081L13.8991 5.89646Z",
    fill: "#999999"
  })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "28",
    cy: "28",
    r: "20",
    fill: "#212121",
    "fill-opacity": "0.2"
  }),
  /*#__PURE__*/_createElementVNode("g", { opacity: "0.8" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M33.1441 26.4716C34.0828 27.0557 34.0828 28.5299 33.1441 29.114L26.3015 33.3723C25.37 33.9521 24.2109 33.2195 24.2109 32.0511L24.2109 23.5345C24.2109 22.3661 25.37 21.6335 26.3015 22.2132L33.1441 26.4716Z",
      fill: "white"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M40.6553 28.0006C40.6553 21.0104 34.9892 15.343 27.999 15.3427C21.0086 15.3427 15.3411 21.0102 15.3411 28.0006C15.3415 34.9908 21.0088 40.6569 27.999 40.6569C34.989 40.6566 40.655 34.9906 40.6553 28.0006ZM43.9886 28.0006C43.9883 36.8315 36.83 43.9899 27.999 43.9902C19.1678 43.9902 12.0081 36.8317 12.0078 28.0006C12.0078 19.1692 19.1676 12.0094 27.999 12.0094C36.8302 12.0097 43.9886 19.1694 43.9886 28.0006Z",
      fill: "white"
    })
  ])
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.8991 5.89646C14.2896 5.50599 14.9228 5.50607 15.3133 5.89646C15.7038 6.28699 15.7038 6.92016 15.3133 7.31068L10.6239 12.0001L15.3133 16.6895L15.3823 16.7655C15.7025 17.1582 15.6793 17.7377 15.3133 18.1037C14.9472 18.4696 14.3677 18.4929 13.975 18.1728L13.8991 18.1037L8.71454 12.9192C8.20709 12.4116 8.20718 11.5886 8.71454 11.081L13.8991 5.89646Z",
    fill: "#999999"
  })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "frisbuy-popup-content__media-counter"
}
const _hoisted_16 = {
  key: 0,
  class: "frisbuy-popup-customers-reviews"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Другие фото из отзывов", -1))
const _hoisted_18 = { class: "frisbuy-popup-media-list" }

import {
  ref,
  watch,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
} from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
// Components
import PopupContainer from "../PopupContainer/PopupContainer.vue";
import CustomerReview from "../CustomerReview.vue";
import MediaList from "../MediaList.vue";
import MobileReviewSheet from "../MobileReviewSheet.vue";
import PopupReviewMediaList from "../PopupReviewMediaList.vue";
import PopupReviewMobileMediaSlider from "../PopupReviewMobileMediaSlider.vue";
import PopupReviewMobileVideoControls from "./PopupReviewMobileVideoControls.vue";
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";
// Types
import { TSwipe } from "../../globals";
import { imageWithPostId, IMarketplaceReviewsPost } from "../../interfaces";

const PRELOAD_MEDIA_BEFORE_END = 2;

export default /*#__PURE__*/_defineComponent({
  __name: 'PopupReviewPost',
  props: {
    post: {},
    selectedPostIndex: {},
    selectedMediaIndex: {},
    showLeftArrow: { type: Boolean, default: true },
    showRightArrow: { type: Boolean, default: true },
    settings: {},
    allCustomersMediaList: { default: () => [] },
    totalMediaCount: {},
    reviewDate: {},
    reviewTime: {}
  },
  emits: [
  "selectPrevPost",
  "selectNextPost",
  "close",
  "selectPost",
  "requestToLoadCustomersMedia",
  "sendAnaliticEvent",
],
  setup(__props: any, { emit: __emit }) {

// Modules
const props = __props;

const emit = __emit;

const currentMediaIndex = ref<number>(props.selectedMediaIndex);
const swiperMediaList = computed<imageWithPostId[]>(() => {
  if (props.allCustomersMediaList.length) {
    return props.allCustomersMediaList;
  }

  return props.post.media.map((media) => ({
    thumbnailUrl: media.thumbnailUrl,
    imageUrl: media.imageUrl,
    imageHighResolutionUrl: media.imageHighResolutionUrl,
    videoUrl: media.videoUrl,
    postId: media.postId,
  }));
});
const popupMediaCount = computed<number>(() => {
  return props.totalMediaCount ?? swiperMediaList.value.length;
});
const isMediaNavigationVisible = computed<boolean>(
  () => popupMediaCount.value > 1
);
const canSlidePrev = computed<boolean>(() => {
  return isMediaNavigationVisible.value && currentMediaIndex.value > 0;
});
const canSlideNext = computed<boolean>(() => {
  return (
    isMediaNavigationVisible.value &&
    currentMediaIndex.value < popupMediaCount.value - 1
  );
});
const hasMoreCustomersMedia = computed<boolean>(() => {
  if (typeof props.totalMediaCount !== "number") {
    return true;
  }

  return props.allCustomersMediaList.length < props.totalMediaCount;
});
const isMobileReviewSheetOpen = ref(false);
const isPopupReadMoreExpanded = ref(false);
const isMobileViewport = ref(false);
const swiperInstance = ref<any | null>(null);
const isSwiperSyncing = ref(false);
const isSelectingFromSwiper = ref(false);
const didRequestAtSwiperEnd = ref(false);

function updateViewportMode() {
  isMobileViewport.value = window.innerWidth <= 1024;
}

const currentMedia = computed<imageWithPostId | undefined>(() => {
  return swiperMediaList.value[currentMediaIndex.value];
});
const currentPostMediaThumbnailUrl = computed<string | undefined>(() => {
  const currentPostId =
    props.post.instagramPost?.frisbuyId ?? props.post.providerPost?.frisbuyId;
  const globalMedia = currentMedia.value;

  if (globalMedia?.postId === currentPostId) {
    return globalMedia.thumbnailUrl;
  }

  const localMedia = props.post.media[props.selectedMediaIndex];
  return localMedia?.thumbnailUrl;
});
const isCurrentMediaVideo = computed<boolean>(() => {
  return Boolean(currentMedia.value?.videoUrl?.length);
});
const isMobileMediaHiddenAfterVideoStart = ref(false);
const isMobileMediaVisible = computed<boolean>(() => {
  if (!isMobileViewport.value) return false;
  if (!isMobileMediaHiddenAfterVideoStart.value) return true;
  return !isCurrentMediaVideo.value;
});
const videoElements = ref<(HTMLVideoElement | null)[]>([]);
const videoElement = computed<HTMLVideoElement | null>(() => {
  return videoElements.value[currentMediaIndex.value] || null;
});
const isVideoStarted = ref(false);
const isVideoPlaying = ref(false);

function setVideoRef(el: HTMLVideoElement | null, index: number) {
  videoElements.value[index] = el;
}

watch(
  () => [props.post, props.selectedMediaIndex, props.allCustomersMediaList],
  () => {
    if (isSelectingFromSwiper.value) {
      isSelectingFromSwiper.value = false;
      return;
    }

    const currentPostId =
      props.post.instagramPost?.frisbuyId ?? props.post.providerPost?.frisbuyId;
    const currentPostMedia = props.post.media[props.selectedMediaIndex];
    const targetMediaIndex = resolveGlobalMediaIndex(
      currentPostId,
      props.selectedMediaIndex,
      currentPostMedia
    );

    currentMediaIndex.value = targetMediaIndex >= 0 ? targetMediaIndex : 0;

    isPopupReadMoreExpanded.value = false;
    isVideoStarted.value = false;
    isVideoPlaying.value = false;

    // Miniatures become available again only after switching to an image slide.
    if (!isCurrentMediaVideo.value) {
      isMobileMediaHiddenAfterVideoStart.value = false;
    }

    nextTick(() => {
      if (!swiperInstance.value) return;
      if (swiperInstance.value.activeIndex === currentMediaIndex.value) return;

      isSwiperSyncing.value = true;
      swiperInstance.value.slideTo(currentMediaIndex.value, 0);
    });

    checkNeedLoadBySelectedMedia();
  },
  { immediate: true }
);

function selectPrevPost() {
  emit("selectPrevPost");
}

function selectNextPost() {
  emit("selectNextPost");
}

function selectPrevMedia() {
  if (!swiperInstance.value || !canSlidePrev.value) return;
  swiperInstance.value.slidePrev();
}

function selectNextMedia() {
  if (!swiperInstance.value || !canSlideNext.value) return;
  swiperInstance.value.slideNext();
}

function swipePost(direction: TSwipe) {
  if (direction === "left") {
    selectNextPost();
  }

  if (direction === "right") {
    selectPrevPost();
  }
}

function onSwiperInit(swiper: any) {
  swiperInstance.value = swiper;
}

function onSlideChange(swiper: any) {
  currentMediaIndex.value = swiper.activeIndex || 0;

  if (isVideoStarted.value) {
    stopVideo();
  }

  if (isSwiperSyncing.value) {
    isSwiperSyncing.value = false;
    return;
  }

  const selectedMedia = swiperMediaList.value[currentMediaIndex.value];
  if (!selectedMedia) return;

  const targetPostId = resolveMediaPostId(selectedMedia);
  if (targetPostId < 0) {
    return;
  }

  isSelectingFromSwiper.value = true;
  selectPost(targetPostId, selectedMedia);
  checkNeedLoadBySelectedMedia();
}

function shouldPreloadBySelectedMedia() {
  if (!swiperMediaList.value.length) {
    return false;
  }

  return (
    currentMediaIndex.value >=
    swiperMediaList.value.length - 1 - PRELOAD_MEDIA_BEFORE_END
  );
}

function checkNeedLoadBySelectedMedia() {
  if (!hasMoreCustomersMedia.value) {
    didRequestAtSwiperEnd.value = false;
    return;
  }

  const isNearEnd = shouldPreloadBySelectedMedia();

  if (isNearEnd && !didRequestAtSwiperEnd.value) {
    didRequestAtSwiperEnd.value = true;
    emit("requestToLoadCustomersMedia");
    return;
  }

  if (!isNearEnd) {
    didRequestAtSwiperEnd.value = false;
  }
}

function closePopup() {
  emit("close");
}

function selectMedia(media: imageWithPostId) {
  if (isVideoPlaying.value) {
    stopVideo();
  }

  const localMediaIndex = findLocalMediaIndex(media);
  const postId = resolveMediaPostId(media);
  if (postId < 0) {
    return;
  }

  selectPost(postId, media, localMediaIndex);
}

function onModalMediaSelect(media: imageWithPostId) {
  const localMediaIndex = findLocalMediaIndex(media);
  const targetPostId = getCurrentPostId(media.postId);
  const targetGlobalIndex = resolveGlobalMediaIndexByPostAndLocalIndex(
    targetPostId,
    Math.max(localMediaIndex, 0)
  );

  if (!swiperInstance.value || targetGlobalIndex < 0) {
    selectMedia(media);
    return;
  }

  if (swiperInstance.value.activeIndex === targetGlobalIndex) {
    return;
  }

  swiperInstance.value.slideTo(targetGlobalIndex);
}

function playVideo() {
  if (!videoElement.value) {
    console.warn("videoElement is 'null'");
    return;
  }

  emit("sendAnaliticEvent", "PlayVideo", {
    provPostId:
      props.post.instagramPost?.frisbuyId ?? props.post.providerPost.frisbuyId,
    fbProduct: props.post.frisbuyPost.id,
    igCode: props.post.instagramPost.shortcode,
  });

  isVideoPlaying.value = true;
  isVideoStarted.value = true;
  isMobileMediaHiddenAfterVideoStart.value = true;

  videoElement.value.play().catch(() => {
    isVideoPlaying.value = false;
  });
}

function toggleVideoPlayback() {
  if (!videoElement.value) {
    return;
  }

  if (videoElement.value.paused) {
    isVideoPlaying.value = true;
    videoElement.value.play().catch(() => {
      isVideoPlaying.value = false;
    });
    return;
  }

  pauseVideo();
}

function onVideoClick() {
  toggleVideoPlayback();
}

function onVideoPlay() {
  isVideoStarted.value = true;
  isVideoPlaying.value = true;
}

function onVideoPause() {
  isVideoPlaying.value = false;
}

function pauseVideo() {
  if (!videoElement.value) {
    console.warn("videoElement is 'null'");
    return;
  }

  isVideoPlaying.value = false;

  videoElement.value.pause();
}

function stopVideo() {
  if (!videoElement.value) {
    console.warn("videoElement is 'null'");
    return;
  }

  isVideoStarted.value = false;
  isVideoPlaying.value = false;

  videoElement.value.pause();
  videoElement.value.currentTime = 0;
}

function normalizeMediaUrl(url?: string) {
  if (!url) return "";

  return url
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\/[^/]+/i, "")
    .replace(/[?#].*$/, "");
}

function resolveMediaPostId(media: imageWithPostId): number {
  const directPostId = Number(media.postId);
  if (Number.isFinite(directPostId) && directPostId > 0) {
    return directPostId;
  }

  const mediaThumb = normalizeMediaUrl(media.thumbnailUrl);
  const mediaHighRes = normalizeMediaUrl(media.imageHighResolutionUrl);
  const mediaImage = normalizeMediaUrl(media.imageUrl);
  const mediaVideo = normalizeMediaUrl(media.videoUrl);

  const matchedGlobalMedia = props.allCustomersMediaList.find((item) => {
    const itemThumb = normalizeMediaUrl(item.thumbnailUrl);
    const itemHighRes = normalizeMediaUrl(item.imageHighResolutionUrl);
    const itemImage = normalizeMediaUrl(item.imageUrl);
    const itemVideo = normalizeMediaUrl(item.videoUrl);

    return (
      (mediaThumb && itemThumb && mediaThumb === itemThumb) ||
      (mediaHighRes && itemHighRes && mediaHighRes === itemHighRes) ||
      (mediaImage && itemImage && mediaImage === itemImage) ||
      (mediaVideo && itemVideo && mediaVideo === itemVideo)
    );
  });

  const matchedPostId = Number(matchedGlobalMedia?.postId);
  if (Number.isFinite(matchedPostId) && matchedPostId > 0) {
    return matchedPostId;
  }

  const currentPostId = Number(
    props.post.instagramPost?.frisbuyId ?? props.post.providerPost?.frisbuyId
  );
  return Number.isFinite(currentPostId) && currentPostId > 0
    ? currentPostId
    : -1;
}

// Customers photo
function selectPost(
  postId: number,
  media?: imageWithPostId,
  localMediaIndex?: number
) {
  if (isVideoStarted.value) {
    stopVideo();
  }

  emit("selectPost", postId, media, localMediaIndex);
}

// Customers photo loading on scroll
function loadCustomersMediaOnScroll(scrollPos: {
  top: number;
  bottom: number;
}) {
  if (scrollPos.bottom <= 0 && hasMoreCustomersMedia.value) {
    emit("requestToLoadCustomersMedia");
  }
}

// MediaList items size
onMounted(() => {
  updateViewportMode();
  window.addEventListener("resize", updateViewportMode);
  changeAllCustomersMediaListItemsWidth();
  window.addEventListener("resize", changeAllCustomersMediaListItemsWidth);

  changeReviewMediaListItemsWidth();
  window.addEventListener("resize", changeReviewMediaListItemsWidth);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateViewportMode);
  window.removeEventListener("resize", changeAllCustomersMediaListItemsWidth);
  window.removeEventListener("resize", changeReviewMediaListItemsWidth);
});

const reviewMediaListItemsWidth = ref<string>();
function changeReviewMediaListItemsWidth() {
  let itemsWidth = "65px";

  if (document.body.clientWidth <= 1024) {
    itemsWidth = "87px";
  }

  reviewMediaListItemsWidth.value = itemsWidth;
}

let allCustomersMediaListItemsWidth = ref<string>();
function changeAllCustomersMediaListItemsWidth() {
  let gap = "5px";
  let itemsInRow = 6;

  if (document.body.clientWidth <= 767) {
    itemsInRow = 2;
  } else if (document.body.clientWidth <= 1024) {
    itemsInRow = 3;
  } else {
    itemsInRow = 6;
  }

  allCustomersMediaListItemsWidth.value = `calc(1 / ${itemsInRow} * 100% - calc(${gap} * ${
    (itemsInRow - 1) / itemsInRow
  })`;
}

function errorImageHandler(e: Event) {
  MediaCatcher(e, 2, widgetTypes.STORY);
}

function resolveGlobalMediaIndex(
  postId: number,
  localMediaIndex: number,
  media?: imageWithPostId
) {
  if (!swiperMediaList.value.length) return -1;

  const samePostIndexes: number[] = [];
  swiperMediaList.value.forEach((item, idx) => {
    if (String(item.postId) === String(postId)) {
      samePostIndexes.push(idx);
    }
  });

  if (samePostIndexes.length) {
    const indexByLocal = samePostIndexes[localMediaIndex];
    if (typeof indexByLocal === "number") {
      return indexByLocal;
    }
  }

  if (media) {
    const exactIndex = swiperMediaList.value.findIndex((item) => {
      if (String(item.postId) !== String(postId)) return false;

      return (
        item.thumbnailUrl === media.thumbnailUrl ||
        item.imageHighResolutionUrl === media.imageHighResolutionUrl ||
        item.imageUrl === media.imageUrl ||
        item.videoUrl === media.videoUrl
      );
    });

    if (exactIndex >= 0) {
      return exactIndex;
    }
  }

  if (!samePostIndexes.length) return -1;
  return samePostIndexes[localMediaIndex] ?? samePostIndexes[0];
}

function resolveGlobalMediaIndexByPostAndLocalIndex(
  postId: number,
  localMediaIndex: number
) {
  const samePostIndexes: number[] = [];

  swiperMediaList.value.forEach((item, idx) => {
    if (String(item.postId) === String(postId)) {
      samePostIndexes.push(idx);
    }
  });

  if (!samePostIndexes.length) return -1;
  return samePostIndexes[localMediaIndex] ?? samePostIndexes[0];
}

function getCurrentPostId(overridePostId?: number) {
  return (
    overridePostId ||
    props.post.instagramPost?.frisbuyId ||
    props.post.providerPost?.frisbuyId
  );
}

function findLocalMediaIndex(media: imageWithPostId) {
  const directIndex = props.post.media.indexOf(media as any);
  if (directIndex >= 0) {
    return directIndex;
  }

  return props.post.media.findIndex((postMedia) => {
    return (
      (postMedia.thumbnailUrl &&
        media.thumbnailUrl &&
        postMedia.thumbnailUrl === media.thumbnailUrl) ||
      (postMedia.imageHighResolutionUrl &&
        media.imageHighResolutionUrl &&
        postMedia.imageHighResolutionUrl === media.imageHighResolutionUrl) ||
      (postMedia.imageUrl &&
        media.imageUrl &&
        postMedia.imageUrl === media.imageUrl) ||
      (postMedia.videoUrl &&
        media.videoUrl &&
        postMedia.videoUrl === media.videoUrl)
    );
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupContainer, {
    isSwipeEnabled: false,
    onClose: closePopup,
    onBlur: closePopup,
    onSwipe: _cache[7] || (_cache[7] = (direction) => swipePost(direction)),
    onScroll: _cache[8] || (_cache[8] = (scrollPos) => loadCustomersMediaOnScroll(scrollPos))
  }, {
    content: _withCtx((contentWrapper) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(currentMediaIndex.value + 1) + "/" + _toDisplayString(popupMediaCount.value), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["frisbuy-popup-content", {
            'frisbuy-popup-content--video-playing':
              isMobileViewport.value && isCurrentMediaVideo.value && isVideoPlaying.value,
          }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Swiper), {
                class: "frisbuy-popup-content__swiper",
                "initial-slide": currentMediaIndex.value,
                "allow-touch-move": isMobileViewport.value,
                onSwiper: onSwiperInit,
                onSlideChange: onSlideChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(swiperMediaList.value, (media, mediaIndex) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                      key: `${media.postId}-${media.thumbnailUrl || mediaIndex}`,
                      class: "frisbuy-popup-content__slide"
                    }, {
                      default: _withCtx(() => [
                        (!media.videoUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: 
                      _unref(DomainSubstitute)(
                        media.imageHighResolutionUrl || media.imageUrl
                      )
                    ,
                              onError: errorImageHandler
                            }, null, 40, _hoisted_6))
                          : (
                      !isVideoStarted.value || currentMediaIndex.value !== mediaIndex
                    )
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: 
                      _unref(DomainSubstitute)(
                        media.imageHighResolutionUrl || media.imageUrl
                      )
                    ,
                                onError: errorImageHandler
                              }, null, 40, _hoisted_7))
                            : _createCommentVNode("", true),
                        (media.videoUrl)
                          ? _withDirectives((_openBlock(), _createElementBlock("video", {
                              key: 2,
                              src: media.videoUrl,
                              muted: "",
                              loop: "true",
                              playsinline: "",
                              controls: !isMobileViewport.value && isVideoStarted.value,
                              ref_for: true,
                              ref: 
                      (el) => setVideoRef(el as HTMLVideoElement | null, mediaIndex)
                    ,
                              onClick: _withModifiers(onVideoClick, ["stop","prevent"]),
                              onPlay: onVideoPlay,
                              onPause: onVideoPause
                            }, null, 40, _hoisted_8)), [
                              [_vShow, isVideoStarted.value && currentMediaIndex.value === mediaIndex]
                            ])
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["initial-slide", "allow-touch-move"]),
              (isMediaNavigationVisible.value && canSlidePrev.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "frisbuy-popup-content__button frisbuy-popup-content__button--left",
                    onClick: selectPrevMedia
                  }, _hoisted_10))
                : _createCommentVNode("", true),
              (currentMedia.value?.videoUrl && !isVideoStarted.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "frisbuy-popup-content__play-icon",
                    onClick: playVideo
                  }, _hoisted_12))
                : _createCommentVNode("", true),
              (isMediaNavigationVisible.value && canSlideNext.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "frisbuy-popup-content__button frisbuy-popup-content__button--right",
                    onClick: selectNextMedia
                  }, _hoisted_14))
                : _createCommentVNode("", true),
              (
                  isMediaNavigationVisible.value && canSlidePrev.value && !isVideoStarted.value
                )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: "frisbuy-popup-content__click-zone frisbuy-popup-content__click-zone--left",
                    type: "button",
                    "aria-label": "Previous media",
                    onClick: selectPrevMedia
                  }))
                : _createCommentVNode("", true),
              (
                  isMediaNavigationVisible.value && canSlideNext.value && !isVideoStarted.value
                )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 4,
                    class: "frisbuy-popup-content__click-zone frisbuy-popup-content__click-zone--right",
                    type: "button",
                    "aria-label": "Next media",
                    onClick: selectNextMedia
                  }))
                : _createCommentVNode("", true)
            ]),
            (isMediaNavigationVisible.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(currentMediaIndex.value + 1) + "/" + _toDisplayString(popupMediaCount.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["frisbuy-popup-content__bottom-layer", {
              'frisbuy-popup-content__bottom-layer--video-playing':
                isMobileViewport.value && isCurrentMediaVideo.value && isVideoPlaying.value,
            }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["frisbuy-popup-content__info", {
                'frisbuy-popup-content__info--expanded':
                  isPopupReadMoreExpanded.value,
                'frisbuy-popup-content__info--video-interface-visible':
                  isMobileViewport.value && isCurrentMediaVideo.value && isVideoPlaying.value,
              }])
            }, [
              _createVNode(CustomerReview, {
                customerName: 
                  _ctx.post.instagramPost.authorUser.fio ||
                  `@${_ctx.post.instagramPost.authorUser.username}`
                ,
                avatarColorIndex: props.selectedPostIndex + 1,
                reviewDate: props.reviewDate,
                reviewTime: props.reviewTime,
                rating: _ctx.post.frisbuyPost.rating,
                negativeComment: _ctx.post.frisbuyPost.negativeComment,
                positiveComment: _ctx.post.frisbuyPost.positiveComment,
                text: _ctx.post.frisbuyPost.text,
                isShowMedia: false,
                authorView: "popup",
                sectionsMarginTop: ['0', '20px', '30px'],
                onSelectMedia: _cache[1] || (_cache[1] = (media) => selectMedia(media)),
                onPopupReadMoreToggle: _cache[2] || (_cache[2] = 
                  (expanded) => (isPopupReadMoreExpanded.value = expanded)
                )
              }, {
                topRight: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "frisbuy-popup-content__open-review frisbuy-popup-content__open-review--inline",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (isMobileReviewSheetOpen.value = true))
                  }, " См. отзыв ")
                ]),
                _: 1
              }, 8, ["customerName", "avatarColorIndex", "reviewDate", "reviewTime", "rating", "negativeComment", "positiveComment", "text"]),
              (isMobileViewport.value && isMobileMediaVisible.value)
                ? (_openBlock(), _createBlock(PopupReviewMobileMediaSlider, {
                    key: 0,
                    class: "frisbuy-popup-content__modal-media",
                    mediaList: props.post.media,
                    selectedMediaThumbnailUrl: currentPostMediaThumbnailUrl.value,
                    onSelectMedia: _cache[3] || (_cache[3] = (media) => onModalMediaSelect(media))
                  }, null, 8, ["mediaList", "selectedMediaThumbnailUrl"]))
                : _createCommentVNode("", true),
              (!isMobileViewport.value)
                ? (_openBlock(), _createBlock(PopupReviewMediaList, {
                    key: 1,
                    class: "frisbuy-popup-content__modal-media",
                    mediaList: props.post.media,
                    selectedMediaThumbnailUrl: currentPostMediaThumbnailUrl.value,
                    onSelectMedia: _cache[4] || (_cache[4] = (media) => onModalMediaSelect(media))
                  }, null, 8, ["mediaList", "selectedMediaThumbnailUrl"]))
                : _createCommentVNode("", true)
            ], 2),
            (isMobileViewport.value && isCurrentMediaVideo.value && isVideoPlaying.value)
              ? (_openBlock(), _createBlock(PopupReviewMobileVideoControls, {
                  key: 0,
                  videoEl: videoElement.value
                }, null, 8, ["videoEl"]))
              : _createCommentVNode("", true)
          ], 2)
        ], 2),
        (props.allCustomersMediaList.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createVNode(MediaList, {
                  mediaList: props.allCustomersMediaList,
                  mediaWidth: _unref(allCustomersMediaListItemsWidth),
                  wrap: "wrap",
                  onSelectMedia: 
                (media) => {
                  selectPost(media.postId, media);

                  // NOTE: `nextTick` only for fix Safari
                  nextTick(() => {
                    contentWrapper.scrollToTop();
                  });
                }
              
                }, null, 8, ["mediaList", "mediaWidth", "onSelectMedia"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(MobileReviewSheet, {
        isOpen: isMobileReviewSheetOpen.value,
        post: _ctx.post,
        reviewIndex: props.selectedPostIndex + 1,
        reviewDate: props.reviewDate,
        selectedMediaThumbnailUrl: currentMedia.value?.thumbnailUrl,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (isMobileReviewSheetOpen.value = false)),
        onSelectMedia: _cache[6] || (_cache[6] = (media) => selectMedia(media))
      }, null, 8, ["isOpen", "post", "reviewIndex", "reviewDate", "selectedMediaThumbnailUrl"])
    ]),
    _: 1
  }))
}
}

})